import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const contactLinkSx = {
  color: "inherit",
  textDecoration: "none",
  minWidth: 0,
  opacity: 0.88,
  transition: "opacity .2s ease",
  "&:hover": { opacity: 1 },
};

function SocialLink({ href, label, children, style }) {
  if (!href) return null;
  return (
    <IconButton
      component="a"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      size="small"
      sx={{
        width: 30,
        height: 30,
        color: style?.socialIconColor || "#FFFFFF",
        opacity: 0.82,
        "&:hover": { opacity: 1, bgcolor: style?.socialHoverBackgroundColor || "rgba(255,255,255,.1)" },
      }}
    >
      {children}
    </IconButton>
  );
}

export default function NavbarTopbar({
  visible,
  style = {},
  borderRadius = null,
  business,
  businessAddress,
  whatsappUrl,
  showSocialLinks,
}) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        display: { xs: "none", md: "block" },
        bgcolor: style.backgroundColor || "#19242F",
        color: style.textColor || "#FFFFFF",
        borderBottom: "1px solid",
        borderColor: style.borderColor || "rgba(255,255,255,.1)",
        ...(Number.isFinite(borderRadius)
          ? {
              borderTopLeftRadius: `${borderRadius}px`,
              borderTopRightRadius: `${borderRadius}px`,
            }
          : {}),
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ maxWidth: 1440, minHeight: 38, mx: "auto", px: { md: 4, lg: 5 } }}
      >
        <Stack direction="row" spacing={2.2} alignItems="center" sx={{ minWidth: 0 }}>
          {business?.phone ? (
            <Stack
              component="a"
              href={`tel:${business.phone}`}
              direction="row"
              spacing={0.7}
              alignItems="center"
              sx={contactLinkSx}
            >
              <PhoneOutlinedIcon sx={{ fontSize: 16, color: style.iconColor || "#F35A3A" }} />
              <Typography variant="caption" sx={{ fontWeight: 800 }}>
                {business.phone}
              </Typography>
            </Stack>
          ) : null}

          {business?.email ? (
            <Stack
              component="a"
              href={`mailto:${business.email}`}
              direction="row"
              spacing={0.7}
              alignItems="center"
              sx={{ ...contactLinkSx, display: { md: "none", lg: "flex" } }}
            >
              <EmailOutlinedIcon sx={{ fontSize: 16, color: style.iconColor || "#F35A3A" }} />
              <Typography variant="caption" noWrap sx={{ fontWeight: 750 }}>
                {business.email}
              </Typography>
            </Stack>
          ) : null}

          {businessAddress ? (
            <Stack
              direction="row"
              spacing={0.7}
              alignItems="center"
              sx={{ minWidth: 0, display: { md: "none", xl: "flex" }, opacity: 0.76 }}
            >
              <LocationOnOutlinedIcon sx={{ fontSize: 16, color: style.iconColor || "#F35A3A" }} />
              <Typography variant="caption" noWrap>
                {businessAddress}
              </Typography>
            </Stack>
          ) : null}
        </Stack>

        {showSocialLinks ? (
          <Stack direction="row" spacing={0.15} alignItems="center">
            <SocialLink href={whatsappUrl} label="WhatsApp" style={style}>
              <WhatsAppIcon sx={{ fontSize: 17 }} />
            </SocialLink>
            <SocialLink href={business?.socials?.instagram} label="Instagram" style={style}>
              <InstagramIcon sx={{ fontSize: 17 }} />
            </SocialLink>
            <SocialLink href={business?.socials?.facebook} label="Facebook" style={style}>
              <FacebookIcon sx={{ fontSize: 17 }} />
            </SocialLink>
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
